import EmptyItemView from "../view/empty-item.js";

export default class EmptyPresenter {
  constructor() {
    this._view = new EmptyItemView();
  }

  init() {}

  destroy() {}

  getElement() {}

  resetView() {}
}
